import axios from "axios";
import i18n from "i18next";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const setAuthToken = (token) => {
    if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.common["Authorization"];
    }
};

axios.interceptors.request.use(
    (config) => {
        const lang = i18n.language || "uz";
        config.headers["Accept-Language"] = lang;
        return config;
    },
    (error) => Promise.reject(error)
);

export default axios;
